<template>
  <!--
      作者：gmshop
      时间：2020-06-01
      描述：插件中心-服务-编辑
    -->
  <div class="product-add pb50" v-loading="loading">
    <!--编辑服务-->
     <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
       <div class="common-form">编辑服务</div>
      <el-form-item label="名称" prop="name"><el-input v-model="form.name" placeholder="请输入名称" class="max-w460"></el-input></el-form-item>
      <el-form-item label="标题" prop="title"><el-input v-model="form.title" placeholder="请输入标题" class="max-w460"></el-input></el-form-item>
      <el-form-item label="价格" prop="price"><el-input type="number" v-model="form.price" placeholder="请输入价格" class="max-w460"></el-input></el-form-item>
      <el-form-item label="限制总数" prop="limit_total">
        <el-input type="number" v-model="form.limit_total" placeholder="请输入限制总数" class="max-w460"></el-input>
        <div class="tips">-1不限制</div>
      </el-form-item>
      <el-form-item label="缩略图" prop="image_id">
        <div>
          <el-button type="primary" @click="openUpload">上传图片</el-button>
          <img class="mt10" :src="image.file_path"  width="120px;" alt="" />
          <!--上传图片组件-->
          <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
        </div>
      </el-form-item>
      <el-form-item label="适用门店" prop="store_type">
        <el-radio-group v-model="form.store_type">
          <el-radio :label="10">全部门店</el-radio>
          <el-radio :label="20">指定门店</el-radio>
          <!-- <el-radio :label="30">指定区域</el-radio> -->
        </el-radio-group>
      </el-form-item>
      <el-form-item v-model="form.store_ids" prop="store_ids" v-if="form.store_type == 20" label="选择门店" :rules="[{ required: true, message: '请选择门店' }]">
        <el-row>
          <el-button type="primary" icon="el-icon-plus" @click="openStoreDialog">选择门店</el-button>
          <div class="draggable-list">
            <div v-for="(item,index) in stores" :key="index" class="item">
              <div style="height:100%">
                <div>
                  <img class="img" :src="item.logo.file_path" />
                  <div class="store-name">{{item.store_name}}</div>
                </div>
              </div>
              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
            </div>
          </div>
        </el-row>
      </el-form-item>

      <!-- <el-form-item v-model="form.region" prop="region" v-if="form.store_type == 30" label="选择地区" :rules="[{ required: true, message: '请选择地区' }]">
        <el-row>
          <el-button type="primary" icon="el-icon-plus" @click="addAreaClick">选择地区</el-button>
          <div class="draggable-list">
            <div v-for="(item,index) in form.stores" :key="index" class="item">
              <div style="height:100%">
                <div>
                  <img class="img" :src="item.logo.file_path" />
                  <div style="height:20px;line-height:20px;">{{item.store_name}}</div>
                </div>
              </div>
              <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
            </div>
          </div>
        </el-row>
      </el-form-item> -->
      <el-form-item label="状态">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">上架</el-radio>
          <el-radio :label="0">下架</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="内容">
        <div class="edit_container">
          <Uediter v-if="!loading" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>
      <el-form-item label="排序"><el-input type="number" v-model="form.sort" placeholder="请输入数字" class="max-w460"></el-input></el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
     </el-form>
    <!--商品选择-->
    <GetStore :is_open="open_store" :excludeIds="excludeIds" :islist="true" @close="closeProductDialog"></GetStore>
  </div>
</template>

<script>
import ServiceApi from '@/api/service.js';
import Uediter from '@/components/UE.vue';
import Upload from '@/components/file/Upload';
import GetStore from '@/components/store/GetStore';
export default {
  components: {
    /*编辑器*/
    Uediter,
    GetStore,
    /*图片上传*/
    Upload
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*是否上传图片*/
      isupload: false,
      open_store:false,
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        title: '',
        limit_total: 0,
        id: '',
        image_id: '',
        sort: 1,
        status: 0,
        content: ''
      },
      image :{},
      /*新闻类别*/
      category: [],
      excludeIds:[],
      stores:[],
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        price: [{ required: true, message: '请输入价格', trigger: 'blur' }],
        limit_total: [{ required: true, message: '请输入限制总数', trigger: 'blur' }],
        image_id: [{ required: true, message: '请选择图片', trigger: 'blur' }],
      }
    };
  },
  created() {

    this.getDetail();

  },

  methods: {

    /*上传*/
    openUpload() {
      this.isupload = true;
    },

    getContent: function() {
      return this.$refs.ue.getUEContent();
    },

    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
        this.image.file_path = e[0].file_path;
      }
      this.isupload = false;
    },

    /*添加门店*/
    openStoreDialog() {
      this.open_store = true;
    },
    /*关闭产品弹窗*/
    closeProductDialog(e) {
      if (e.type != 'error') {
        e.params.forEach(val => {
          if(this.excludeIds.indexOf(val.store_id) == -1) {
            this.excludeIds.push(val.store_id);
            this.stores.push(val);
          }
        });
      }
      this.open_store = false;
    },
    /*删除门店*/
    deleteImg(index) {
      this.excludeIds.splice(index, 1);
      this.stores.splice(index, 1);
    },

    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      const params = self.$route.query.id;
      ServiceApi.getEdit({id: params},true).then(res => {
          self.ueditor.text = res.data.model.content;
          self.form = res.data.model;
          self.excludeIds = self.form.store_ids
          self.stores = self.form.stores
          if(!self.image){
            self.image={};
          }
          self.image = self.form.image
          self.loading = false;
        })
        .catch(error => {});
    },

    /*修改服务*/
    onSubmit() {
      let self = this;
      self.form.content = this.$refs.ue.getUEContent();
      self.form.store_ids = self.excludeIds;
      let params = this.form;
      // 取到路由带过来的参数
      ServiceApi.edit(params, true)
        .then(data => {
          self.$message({
            message: data.msg,
            type: 'success'
          });
          self.$router.push('/service/service/index');
        })
        .catch(error => {});
    },

    /*取消添加，返回服务列表*/
    cancelFunc() {
      this.$router.push({
        path: '/service/service/index'
      });
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .item {
  position: relative;
  width: 110px;
  height: 130px;
  margin-top: 10px;
  margin-right: 10px;
  overflow: hidden;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}
.draggable-list .item .img {
  width: 110px;
  height: 110px;
}
.store-name {
  height:20px;
  line-height:20px;
  background-color: #aaa;
  position: relative;
  top: -20px;
  opacity: 0.9;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/service/service/edit.vue